import { createReducer, on } from '@ngrx/store';
import { saveVehicles } from './vehicles.actions';

export const saveVehiclesReducer = (_: any, { value }: { value: any }): any =>
    value;

export const VehiclesReducer = createReducer(
    [],
    on(saveVehicles, saveVehiclesReducer),
);
